export default __webpack_public_path__ + "static/media/bubble-10.d384ede6.png";